// File: src/hooks/useResearch.tsx
import { useState } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';

import { ResearchIteration } from '../types';
import {
    getResearchResult,
    startResearch,
} from '../services/api';

// <<< ИЗМЕНЕНИЕ 1: Добавляем referenceImageUrl в интерфейс пропсов
interface UseResearchProps {
    selectedProductId: number | '';
    selectedAIServiceCode: string;
    marketplaceCode?: string;
    promptTemplateId: number | '';
    referenceImageUrl: string | null;
}

// <<< ИЗМЕНЕНИЕ 2: Принимаем referenceImageUrl как пропс
export const useResearch = ({ selectedProductId, selectedAIServiceCode, marketplaceCode, promptTemplateId, referenceImageUrl }: UseResearchProps) => {
    const [activeResearchId, setActiveResearchId] = useState<number | null>(null);

    const researchQuery = useQuery({
        queryKey: ['researchResult', activeResearchId],
        queryFn: () => getResearchResult(selectedProductId as number, activeResearchId!),
        enabled: !!activeResearchId && !!selectedProductId,
        refetchInterval: (data) => {
            if (data && (data.status === 'completed' || data.status === 'failed')) {
                return false;
            }
            return 5000;
        },
        refetchOnWindowFocus: false,
    });

    const researchResult = researchQuery.data as ResearchIteration | undefined;
    const researchError = researchQuery.error;

    const startResearchMutation = useMutation({
        // <<< ИЗМЕНЕНИЕ 3: Обновляем тип параметров для мутации
        mutationFn: (params: {
            productId: number,
            ai_service: string,
            marketplaceCode?: string,
            prompt_template_id?: number | null,
            reference_image_url?: string | null;
        }) => startResearch(params),
        onSuccess: (data) => setActiveResearchId(data.id),
        onError: (e) => console.error(e),
    });

    const isRunning = startResearchMutation.isLoading || (!!activeResearchId && researchQuery.isLoading);

    const handleStartResearch = () => {
        if (!selectedProductId) return;
        setActiveResearchId(null);
        // <<< ИЗМЕНЕНИЕ 4: Передаем referenceImageUrl при вызове мутации
        startResearchMutation.mutate({
            productId: selectedProductId as number,
            ai_service: selectedAIServiceCode,
            marketplaceCode: marketplaceCode,
            prompt_template_id: (typeof promptTemplateId === 'number' ? promptTemplateId : null),
            reference_image_url: referenceImageUrl,
        });
    };

    const handleViewResearch = (id: number) => {
        setActiveResearchId(id);
    };

    return {
        researchResult,
        researchError,
        isRunning,
        startResearchMutation,
        handleStartResearch,
        handleViewResearch
    };
};